import React, { useState } from "react";
import TopBar from "@/components/TopBar";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Settings() {
  const { user } = useAuth();
  const [difficulty, setDifficulty] = useState(localStorage.getItem("tlq_diff") || "auto");
  const [notif, setNotif] = useState(localStorage.getItem("tlq_notif") !== "off");

  const save = () => {
    localStorage.setItem("tlq_diff", difficulty);
    localStorage.setItem("tlq_notif", notif ? "on" : "off");
    toast.success("Saved!");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <TopBar variant="parent"/>
      <main className="max-w-2xl mx-auto p-4 sm:p-8">
        <h1 className="font-display text-3xl font-bold text-slate-800 mb-6">Settings</h1>
        <div className="parent-card p-6 space-y-5">
          <Field label="Account">
            <p className="text-slate-700">{user?.name} · {user?.email}</p>
          </Field>
          <Field label="Difficulty">
            <select value={difficulty} onChange={e=>setDifficulty(e.target.value)} data-testid="diff-select"
              className="w-full rounded-xl border border-slate-300 px-3 py-2">
              <option value="auto">AI Adaptive</option>
              <option value="easy">Easy</option>
              <option value="medium">Medium</option>
              <option value="hard">Hard</option>
            </select>
          </Field>
          <Field label="Notifications">
            <label className="inline-flex items-center gap-2">
              <input type="checkbox" checked={notif} onChange={e=>setNotif(e.target.checked)} data-testid="notif-toggle"/>
              <span>Daily summary push</span>
            </label>
          </Field>
          <button onClick={save} data-testid="save-settings"
            className="bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl px-5 py-2 font-semibold">Save</button>
        </div>
      </main>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-widest font-bold text-slate-500 mb-2">{label}</p>
      {children}
    </div>
  );
}
